var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4268 8.25H5.42676C5.01254 8.25 4.67676 8.58579 4.67676 9V19.5C4.67676 19.9142 5.01254 20.25 5.42676 20.25H20.4268C20.841 20.25 21.1768 19.9142 21.1768 19.5V9C21.1768 8.58579 20.841 8.25 20.4268 8.25Z",
    stroke: "#6D737A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55176 8.25V4.875C9.55176 3.97989 9.90734 3.12145 10.5403 2.48851C11.1732 1.85558 12.0317 1.5 12.9268 1.5C13.8219 1.5 14.6803 1.85558 15.3132 2.48851C15.9462 3.12145 16.3018 3.97989 16.3018 4.875V8.25",
    stroke: "#6D737A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9268 15.375C13.5481 15.375 14.0518 14.8713 14.0518 14.25C14.0518 13.6287 13.5481 13.125 12.9268 13.125C12.3054 13.125 11.8018 13.6287 11.8018 14.25C11.8018 14.8713 12.3054 15.375 12.9268 15.375Z",
    fill: "#6D737A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.43ca3987cb3092f2ff97d86b65a32695.svg";
export { ForwardRef as ReactComponent };